import axios from 'axios';
import qs from 'query-string';
import { apiConfig } from '../api-config';
import { GetVoucherParams } from './get-all';

export const getAllVoucherReg = async (params: GetVoucherParams) => {
  const query = qs.stringify(params);
  const validateStatus = (status: number) => (status >= 200 && status <= 300) || status === 404;
  const getAllVoucher = apiConfig.get(`api/Voucher/getAll-by-cadastration?${query}`, { validateStatus });
  const getByCdUser = apiConfig.get(`api/ShareVoucher/get-by-cdUser?${query}`, { validateStatus });
  return axios.all([getAllVoucher, getByCdUser]).then(axios.spread((res1, res3) => ({
    vouchers: res1.data || [],
    total: res3.data.expired || 0,
    avaliable: res3.data.expired,
    used: res3.data.used,
  }))).catch((err) => ({ hasErrors: true, err: err.message }));
};
